import { Navigate, createBrowserRouter } from "react-router";

import App from "./App";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";

export const router = createBrowserRouter([
  {
    Component: App,
    // element: <App />,
    errorElement: <div>sorry something went wrong</div>,
    children: [
      {
        path: "/",
        Component: () => <Layout />,
        children: [
          {
            path: "/",
            Component: LandingPage,
          },
        ],
      },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
